import type { Variants } from 'motion/react';

export function createGridVariants(
  isDesktop: boolean,
  mounted: boolean,
  prefersReducedMotion: boolean,
): Variants {
  return {
    singleColumn: {
      gridTemplateColumns: '1fr 0fr',
    },
    doubleColumn: {
      gridTemplateColumns: isDesktop && mounted ? '1fr 1fr' : '1fr 0fr',
      transition: {
        duration: prefersReducedMotion ? 0 : 0.7,
        delay: prefersReducedMotion ? 0 : 1.5,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  };
}
